import React from 'react'
import { ToastContainer, ToastMessage } from 'react-toastr'

const ToastMessageFactory = React.createFactory(ToastMessage.animation)

class MessageDisplay extends React.Component {
  showSuccess(title, message) {
    this.toastContainer.success(title, message, {
      showAnimation: 'animated fadeInDown', // or other animations from animate.css
      hideAnimation: 'animated fadeOutUp',
      timeOut: 2000,
      extendedTimeOut: 2000
    })
  }

  showError(title, message) {
    this.toastContainer.error(title, message, {
      showAnimation: 'animated fadeInDown', // or other animations from animate.css
      hideAnimation: 'animated fadeOutUp',
      timeOut: 2000,
      extendedTimeOut: 2000
    })
  }

  render() {
    return (
      <ToastContainer
        ref={(toastComponent) => { this.toastContainer = toastComponent }}
        toastMessageFactory={ToastMessageFactory}
        className="toast-top-right"
      />
    )
  }
}

export default MessageDisplay



// WEBPACK FOOTER //
// ./src/components/MessageDisplay/index.jsx